import { TextField } from '@mui/material';
import React, { useRef, useEffect } from 'react';

interface TextFieldProps {
    placeholder: string;
    inputValue: string;
    setInputValue: (value: string) => void;
    label?: string;
    inputMode?: "search" | "text" | "email" | "tel" | "url" | "none" | "numeric" | "decimal" | undefined;
    type?: string;
    styles?: string;
    multiline?: boolean;
    maxRows?: number;
    minRows?: number;
    error?: boolean;
}

export default (props: TextFieldProps) => {
    const { placeholder, inputValue, setInputValue, styles } = props;
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [inputValue]);

    const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(e.target.value);
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
        }
    };

    return (
      <div className={`flex flex-col gap-2 font-BardotBoldItalic ${styles}`}>
        {props.label && <label style={{ color: '#ffffff' }}>{props.label}</label>}
        {/* <textarea
          ref={textareaRef}
          className={`p-2 text-slate-100 text-xl bg-[#1b1a1a] rounded-md border border-slate-600 ${inputValue && 'font-BCBold'} ${styles}`}
          placeholder={placeholder.toUpperCase()}
          value={inputValue}
          onChange={handleInput}
          rows={1} // Start with a single row
          style={{ overflow: 'hidden', resize: 'none', color: '#ffffff' }} // Prevent manual resizing and set font color
        /> */}
        <TextField
          multiline={props.multiline}
          minRows={props.minRows}
          maxRows={props.maxRows}
          onChange={handleInput}
          value={inputValue}
          inputMode={props.inputMode}
          type={props.type}
          error={props.error}
          sx={{
            '& .MuiInputBase-input': { color: '#FFF', fontWeight:'bold',   }, // Updated background color
            '& .MuiInputLabel-root': { fontFamily: 'font-BCBold', color: '#475569', fontSize: '1.2rem' }, // Updated label color
            '& .MuiInputLabel-root.Mui-focused': { fontFamily: 'font-BCBold', color: '#475569', fontSize: '1rem' }, // Updated label color
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#475569' }, // Change outline color on focus
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#64748B' }, // Change outline color on hover
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#475569' } // Change outline color on focus
            , backgroundColor: '#1B1A1A' // Set the background color of the text input
          }}
          label={placeholder.toUpperCase()}
        />
      </div>
    );
}